module.exports = __webpack_public_path__ + "static/ChallengeBuilder-video-d882b59899732148b229559449bedb40.gif";